export default "__VITE_ASSET__78f05564__"